// Reusable circular/radial Queue Health gauge (shared by Agent View + Manager Team Workload)
export function QueueHealthGauge({ score, color, size = 90, stroke = 8, label }) {
  const safeScore = Math.max(0, Math.min(100, score ?? 0));
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ * (1 - safeScore / 100);
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#DAD5CA" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center leading-none">
        <span className="font-bold" style={{ color, fontSize: size * 0.3 }}>{safeScore}</span>
        {label && (
          <span className="text-[#59554D] mt-0.5" style={{ fontSize: Math.max(9, size * 0.13) }}>
            {label}
          </span>
        )}
      </div>
    </div>
  );
}
